export const BULK_EDIT_QUERY_PARAMS = 'action=bulkEdit';
